export default {
    instructionCenter: {
        title: 'AI 指示ライブラリ',
        searchPlaceholder: '指示を検索...',
        gridView: 'グリッド表示',
        listView: 'リスト表示',
        createInstruction: '指示を作成',
        noInstructions: '指示がありません',
        noInstructionsDesc: '「指示を作成」ボタンをクリックして最初の指示を追加してください',
        loading: '読み込み中',
        loadMore: 'もっと見る',
        preview: 'プレビュー',
        edit: '編集',
        delete: '削除',
        cancel: 'キャンセル',
        save: '保存',
        saving: '保存中',
        moreActions: 'その他の操作',
        editInstruction: '指示を編集',
        addFavorite: 'お気に入りに追加',
        removeFavorite: 'お気に入りから削除',
        noResults: '指示が見つかりません',

        // Select Dialog
        selectDialog: {
            title: 'ライブラリから選択',
            forSection: 'セクション用',
        },

        // Technology Area
        technologyArea: {
            general: '一般',
            electrical: '電気',
            mechanical: '機械',
            chemical: '化学',
            software: 'ソフトウェア',
        },

        // Section
        section: {
            title: 'タイトル',
            background: '背景',
            summary: '要約',
            briefFigures: '図面の簡単な説明',
            claims: '請求項',
            abstract: '要約',
            detailed: '詳細な説明',
            detailedPlan: '詳細な説明計画',
            repeatClaims: '請求項の繰り返し',
            custom: 'カスタム',
        },

        // Filter
        filter: {
            title: 'フィルター',
            region: '地域',
            type: 'タイプ',
            from: 'ソース',
            myInstructions: 'マイ指示',
            library: 'ライブラリ',
            clear: '{count} 件のフィルターをクリア',
        },

        // Tabs
        tabs: {
            all: 'すべて',
            title: 'タイトル',
            abstract: '要約',
            background: '背景',
            summary: '発明の内容',
            claims: '請求の範囲',
            detailedDescription: '詳細な説明',
            officeActionResponse: '拒絶理由通知への応答',
            myInstructions: 'マイ指示',
            sharedInstructions: '共有された指示',
            favorites: 'お気に入り',
        },

        // Pills
        pills: {
            all: 'すべての指示',
            my: 'マイ指示',
            official: '公式指示',
            shared: '共有された指示',
            favorites: 'お気に入り',
        },

        // Sections
        sections: {
            title: 'タイトル',
            abstract: '要約',
            background: '背景技術',
            summary: '発明の内容',
            briefFigures: '図面の簡単な説明',
            claims: '請求の範囲',
            detailed: '詳細な説明',
            custom: 'カスタム',
        },

        // Instruction Types
        instructionTypes: {
            patentApplication: '特許出願',
            inventionDisclosure: '発明開示',
            officeActionResponse: '拒絶理由通知への応答',
        },

        // Sources
        sources: {
            system: 'システム',
            custom: 'カスタム',
            library: 'ライブラリ',
        },

        // Dialog
        dialog: {
            name: '指示名',
            namePlaceholder: '指示名を入力してください',
            instructionType: '指示タイプ',
            templateSection: 'テンプレートセクション',
            selectSection: 'テンプレートセクションを選択',
            description: '説明',
            descriptionPlaceholder: '説明を入力してください（任意）',
            descriptionHint: 'この指示の目的と特徴を簡単に説明してください',
            content: 'AI 指示内容',
            contentPlaceholder: 'AI にコンテンツの生成方法を指示する内容を入力してください...',
            contentHint: 'AI がコンテンツを処理および生成する方法について、スタイル、形式、重点などを詳しく説明してください',
            advancedSettings: '詳細設定',
            region: '地域',
            technologyArea: '技術分野',
            optional: '任意',
            quickSettings: 'クイック設定',
            requiredFieldsHint: '* は必須項目を示します',
            fillBasicInfo: '基本情報を入力して新しい指示を作成',
            updateHint: '指示情報を更新',
            viewOnlyHint: 'システム指示の詳細を表示（読み取り専用モード）',
            unsavedChangesTitle: '未保存の変更',
            unsavedChangesMessage: '未保存の変更があります。閉じてもよろしいですか？変更内容は失われます。',
            discardChanges: '変更を破棄',
            continueEditing: '編集を続ける',
            systemReadOnlyHint: 'システム指示は読み取り専用で、編集できません',
            readOnlyPermissionHint: '読み取り専用権限のため、この指示を編集できません',
            close: '閉じる',
            dynamicFields: '動的フィールド',
            noDynamicFields: '動的フィールドは設定されていません。指示内容がそのまま適用されます。',
            addField: 'フィールドを追加',
            removeField: '削除',
            untitledField: '無題のフィールド',
            fieldLabel: 'フィールド名',
            fieldLabelPlaceholder: '例：文体',
            fieldType: 'フィールドタイプ',
            fieldRequired: '必須',
            fieldOptionSource: '選択肢ソース',
            fieldDescription: 'フィールド説明',
            fieldDescriptionPlaceholder: 'このフィールドの用途を説明してください',
            fieldPlaceholder: 'プレースホルダー',
            fieldPlaceholderPlaceholder: 'プレースホルダーを入力',
            fieldDefault: 'デフォルト値',
            fieldDefaultPlaceholder: 'デフォルト値を入力',
            fieldOptions: '選択肢',
            addOption: '選択肢を追加',
            optionLabel: '選択肢名',
            optionValue: '選択肢値',
            yes: 'はい',
            no: 'いいえ',
            none: 'なし',
            fieldTypes: {
                text: '1行テキスト',
                textarea: '複数行テキスト',
                number: '数値',
                select: '単一選択',
                multiSelect: '複数選択',
                boolean: '切替',
            },
            optionSources: {
                claims: '請求項',
                figures: '図面',
            },
            defaultField: 'デフォルト',

            // Level selection (Super Admin only)
            level: '可視性',
            adminOnly: '管理者のみ',
            systemLevel: 'システムレベル',
            userLevel: 'ユーザーレベル',
        },

        defaultFields: {
            labels: {
                word_count: '文字数',
                drawing_reference_marks: '参照符号',
                technical_problem: '技術課題',
                technical_effect: '技術的効果',
                invention_title: '発明の名称',
                two_part_form: '二部形式',
                functional_limitation: '機能的限定',
                multiple_dependency: '多数項従属',
                use_reference_signs: '参照符号を使用',
                markush: 'マーカッシュ',
                multiple_invention_categories: '複数の発明カテゴリー',
                max_independent_claims: '独立請求項の最大数',
                total_claims: '請求項総数',
                claim_indent_format: '請求項インデント形式',
                closest_prior_art: '最も近い先行技術',
            },
            options: {
                auto: '自動',
                allow: '許可',
                forbid: '禁止',
                none: 'なし',
                first_line: '一行目インデント',
                hanging: 'ぶら下げインデント',
            },
            descriptions: {
                drawingReferenceMarksAbstract: '定義した参照符号を要約に含めることができます。',
                technicalProblemAbstract: '定義した技術課題を要約に含めることができます。',
                technicalEffectAbstract: '定義した技術的効果を要約に含めることができます。',
                inventionTitleAbstract: '定義した発明の名称を要約に含めることができます。',
                twoPartForm: '二部形式は、独立請求項を前提部分と特徴部分に分けます。',
                functionalLimitation: '機能的限定は、具体的な構造を定義しない要素を引用する請求項表現です。',
                multipleDependency: '多数項従属請求項は、複数の請求項を引用する従属請求項です。',
                useReferenceSignsClaims: '定義した参照符号を請求項に含めることができます。',
                markush: 'マーカッシュ請求項は、単一の請求項内に複数の排他的な代替要素を含みます。',
                multipleInventionCategories: '請求項で複数の発明カテゴリーを使用できます。',
                closestPriorArt: '提供された各先行技術文献を背景技術に含めます。',
            },
        },

        // Messages
        messages: {
            saveFailed: '保存に失敗しました',
            fetchListFailed: '指示リストの取得に失敗しました',
            fetchDetailFailed: '指示の詳細取得に失敗しました',
            createSuccess: '作成に成功しました',
            createFailed: '作成に失敗しました',
            updateSuccess: '更新に成功しました',
            updateFailed: '更新に失敗しました',
            deleteSuccess: '削除に成功しました',
            deleteFailed: '削除に失敗しました',
            addFavoriteSuccess: 'お気に入りに追加しました',
            removeFavoriteSuccess: 'お気に入りから削除しました',
            favoriteOperationFailed: 'お気に入り操作に失敗しました',
            shareSuccess: '共有に成功しました',
            shareFailed: '共有に失敗しました',
            fetchSharesFailed: '共有リストの取得に失敗しました',
            updateShareSuccess: '共有の更新に成功しました',
            updateShareFailed: '共有の更新に失敗しました',
            deleteShareSuccess: '共有の削除に成功しました',
            deleteShareFailed: '共有の削除に失敗しました',
        },

        // Share
        share: {
            title: '共有',
            shareType: '共有タイプ',
            company: '会社',
            companyShareName: '当社',
            personal: '個人',
            permission: '権限',
            read: '読み取り専用',
            write: '読み書き',
            sharedTo: '共有先',
            expiresAt: '有効期限',
            neverExpires: '無期限',
            expiry7Days: '7日間',
            expiry15Days: '15日間',
            expiry30Days: '30日間',
            shareList: '共有リスト',
            noShares: '共有記録がありません',
            confirmDelete: 'この共有記録を削除してもよろしいですか？',
            cannotShareSystem: 'システム指示は共有できません',
            cannotShareOthers: '自分が作成した指示のみ共有できます',
            enterUserId: 'ユーザーIDを入力してください',
            viewShareList: '共有リストを表示',
            createNew: '共有を作成',
            companyShareDesc: '会社のすべてのメンバーがこの指示にアクセスできます',
            personalShareDesc: '指定されたユーザーのみがこの指示にアクセスできます',
        },
    },
};
